var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"scrollingTextContainer",staticClass:"scrolling-text-container"},[_c('div',{ref:"scrollingText",staticClass:"scrolling-text",style:(_vm.style)},[_vm._v("\n        "+_vm._s(_vm.text)+"\n    ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49b4b9c6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/polymerization/scrollingText.vue
// module id = null
// module chunks = 